/**
 * Metabase modular (guest) embedding config for the reporting app.
 *
 * The site URL is not a secret, so it lives here as a const. The embedding
 * secret key stays on the backend, which signs the guest token we pass to the
 * component. Which question a report embeds is stored per report, not here.
 */

export const METABASE_SITE_URL = "https://vellum.metabaseapp.com";

// Parameter slugs the report questions filter on (from the question's URL).
// Must match luna-lib's report_sending, which filters the emailed CSV.
export const SLUG_COMPANY = "company";
export const SLUG_FACILITY = "facility";
export const SLUG_FROM_DATE = "from_date_filter";
export const SLUG_TO_DATE = "to_date_filter";

let embedRequested = false;

/**
 * Idempotently configure and load Metabase's `embed.js` so `<metabase-question>` works.
 * Sets `window.metabaseConfig` before injecting the script.
 */
export function ensureMetabaseEmbedLoaded(): void {
  if (embedRequested || typeof document === "undefined") {
    return;
  }
  embedRequested = true;

  window.metabaseConfig = { isGuest: true, instanceUrl: METABASE_SITE_URL };

  const script = document.createElement("script");
  script.src = `${METABASE_SITE_URL}/app/embed.js`;
  script.defer = true;
  script.dataset.metabaseEmbed = "true";
  document.head.appendChild(script);
}
